import { render, staticRenderFns } from "./recurringResubscribe.vue?vue&type=template&id=55fb74d0&scoped=true&"
import script from "./recurringResubscribe.vue?vue&type=script&lang=js&"
export * from "./recurringResubscribe.vue?vue&type=script&lang=js&"
import style0 from "./recurringResubscribe.vue?vue&type=style&index=0&id=55fb74d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb74d0",
  null
  
)

export default component.exports